import type { ICheckForgetPassPayload } from "../types";

export const loginApi = async (payload: ILoginPayload) => {
    return await useApi().post("/auth/login", { body: payload });
};

export const signupApi = async (payload: ISignupPayload) => {
    return await useApi().post("/auth/register", { body: payload });
};

export const otpRequestApi = async (payload: IOtpRequestPayload) => {
    return await useApi().post("/auth/otp", { body: payload });
};

export const otpVerifyApi = async (payload: IOtpVerifyPayload) => {
    return await useApi().post("/auth/otp/verify", { body: payload });
};

export const requestResetPassApi = async (payload: IReqForgetPassPayload) => {
    return await useApi().post("/auth/password/reset", { body: payload });
};

export const checkResetPassApi = async ({ code, username }: ICheckForgetPassPayload) => {
    return await useApi().get(`/auth/password/reset/check?username=${username}&code=${code}`);
};

export const changePasswordApi = async (payload: IOtpVerifyPayload) => {
    return await useApi().put("/auth/password/reset", { body: payload });
};
export const postToken = async (payload: { fcm_token: string; device_id: string; notification_status: string }) => {
    return await useApi().post("/payment/account/device", { body: payload });
};
